import React, { Component } from 'react';
import { StyleSheet } from 'react-native';
import { translate, translateFirstUpper } from 'secullum-i18n';
import {
  Card,
  CheckBox,
  DropDown,
  Message,
  Space,
  Text,
  TextBox,
  isTablet,
  Button,
  RED
} from 'secullum-react-native-ui';
import ModalConfirmarEmail from '../../../shared/components/ModalConfirmarEmail';
import { FuncionarioContainer } from '../../../shared/containers/FuncionarioContainer';
import withContainer from '../../../shared/containers/withContainer';
import Api from '../../../shared/modules/api';
import { loadExpressionsAsync } from '../../../shared/modules/i18n';
import {
  carregarConfiguracaoIdiomaAsync,
  salvarConfiguracaoIdiomaAsync,
  ConfiguracoesIdiomasTipo
} from '../../../shared/modules/idiomas';
import { getTheme } from '../../../shared/modules/layout';
import {
  verificarExibirTela,
  exibirTelaInclusaoPonto
} from '../../../shared/modules/perfilFuncionario';
import { Telas } from '../../../shared/modules/telas';
import {
  carregarConfiguracaoSelecionadaTelaInicialAsync,
  salvarConfiguracaoTelaInicialAsync,
  retornarOpcoesTelasIniciais,
  carregarConfiguracaoForcarTelaInicialAsync,
  salvarForcarTelaInicialAsync,
  MINUTOS_LIMITE_FORCAR_TELA_INICIAL
} from '../../../shared/modules/telasIniciais';
import { TipoPlataformaLogin } from '../../../shared/modules/types';
import LoggedInScreen from '../../components/LoggedInScreen';
import { carregarIdentificacaoNavegadorAsync } from '../../modules/browser';
import { navegar, RouteComponentComBancoIdProps } from '../../modules/routes';

interface Props extends RouteComponentComBancoIdProps<{}> {}

interface Props {
  funcionarioContainer: FuncionarioContainer;
}

interface State {
  configuracaoTelaInicial: Telas;
  erroGeral: string;
  mostrarModalConfirmarEmail: boolean;
  forcarTelaInicial: boolean;
  configuracoesIdiomas: ConfiguracoesIdiomasTipo;
}

class Configuracao extends Component<Props, State> {
  state: State = {
    configuracaoTelaInicial: Telas.UltimaTelaAcessada,
    erroGeral: '',
    mostrarModalConfirmarEmail: false,
    forcarTelaInicial: false,
    configuracoesIdiomas: ConfiguracoesIdiomasTipo.PadraoSistema
  };

  api = new Api();

  async componentDidMount() {
    const dadosFuncionario = this.props.funcionarioContainer.state.dados;

    const [configuracaoTelaInicial, forcarTelaInicial, configuracoesIdiomas] =
      await Promise.all([
        carregarConfiguracaoSelecionadaTelaInicialAsync(dadosFuncionario),
        carregarConfiguracaoForcarTelaInicialAsync(),
        carregarConfiguracaoIdiomaAsync()
      ]);

    this.setState({
      configuracaoTelaInicial,
      forcarTelaInicial,
      configuracoesIdiomas
    });

    await this.api.getDadosFuncionario(
      {
        id: dadosFuncionario.id,
        plataformaLogin: TipoPlataformaLogin.Web,
        apelidoDispositivo: 'navegador', // Dados preenchidos para evitar a controller de compatibilidade
        identificacaoDispositivo: await carregarIdentificacaoNavegadorAsync()
      },
      {
        onSuccess: async dados => {
          this.props.funcionarioContainer.setarDadosFuncionario(dados);
        },
        onError: err => {
          this.setState({ erroGeral: err.message });
        }
      }
    );
  }

  handleForcarTelaInicialChange = async (forcar: boolean) => {
    await salvarForcarTelaInicialAsync(forcar);

    this.setState({ forcarTelaInicial: forcar });
  };

  handleDropDownTelasIniciaisChange = async (
    configuracaoTelaInicial: Telas
  ) => {
    await salvarConfiguracaoTelaInicialAsync(configuracaoTelaInicial);

    this.setState({ configuracaoTelaInicial });
  };

  handleReceberEmailComprovantePontoChange = async (
    receberEmailComprovantePonto: boolean
  ) => {
    if (receberEmailComprovantePonto) {
      const dadosFuncionario = this.api.funcionario.state.dados;

      const usuarioTemAcessoDadosCadastrais = verificarExibirTela(
        Telas.DadosCadastrais,
        dadosFuncionario.dadosPerfilFuncionario.telasOcultar
      );

      if (usuarioTemAcessoDadosCadastrais) {
        this.setState({
          mostrarModalConfirmarEmail: true
        });

        return;
      } else if ((dadosFuncionario.email || '') === '') {
        this.setState({
          erroGeral: translate(
            'Você não possui um email cadastrado. Contate o administrador do sistema.'
          )
        });

        return;
      }
    }

    await this.salvarConfiguracaoEmailComprovantePontoAsync(
      receberEmailComprovantePonto
    );
  };

  salvarConfiguracaoEmailComprovantePontoAsync = async (
    receberEmailComprovantePonto: boolean
  ) => {
    await this.api.postConfiguracoesReceberComprovantePonto(
      receberEmailComprovantePonto,
      {
        onSuccess: () => {
          this.props.funcionarioContainer.setState({
            dados: {
              ...this.props.funcionarioContainer.state.dados,
              receberEmailComprovantePonto
            }
          });
        },
        onError: resp => {
          this.setState({
            erroGeral: resp.message
          });
        }
      }
    );
  };

  handleDropDownIdiomasChange = async (
    configuracoesIdiomas: ConfiguracoesIdiomasTipo
  ) => {
    await salvarConfiguracaoIdiomaAsync(configuracoesIdiomas);

    const idioma =
      configuracoesIdiomas === ConfiguracoesIdiomasTipo.PadraoSistema
        ? navigator.language
        : configuracoesIdiomas;

    await loadExpressionsAsync(idioma);

    this.setState({ configuracoesIdiomas });
  };

  render() {
    const { dados } = this.props.funcionarioContainer.state;
    const versaoApp = process.env.REACT_APP_VERSION;

    const itensConfiguracoesIdiomas = [
      {
        value: ConfiguracoesIdiomasTipo.PadraoSistema,
        label: translate('Padrão do sistema'),
        nativeID: 'configuracoes-idioma-padrao-sistema'
      },
      {
        value: ConfiguracoesIdiomasTipo.Portugues,
        label: 'Português',
        nativeID: 'configuracoes-idioma-portugues'
      },
      {
        value: ConfiguracoesIdiomasTipo.Ingles,
        label: 'English',
        nativeID: 'configuracoes-idioma-ingles'
      },
      {
        value: ConfiguracoesIdiomasTipo.Espanhol,
        label: 'Español',
        nativeID: 'configuracoes-idioma-espanhol'
      }
    ];

    return (
      <LoggedInScreen screenTitle={translate('Configurações')}>
        <Message
          type="warning"
          visible={this.state.erroGeral !== ''}
          message={this.state.erroGeral}
          onRequestClose={() => {
            this.setState({ erroGeral: '' });
          }}
        />
        <Card>
          <Card.Header
            nativeID="configuracoes-texto-explicativo"
            title={translate(
              'A tela inicial é a página que será exibida após você efetuar o login.'
            )}
            titleStyle={styles.titleHeader}
          />
          <Card.Section style={styles.section}>
            <DropDown
              nativeID="configuracoes-tela-inicial"
              label={translate('Tela Inicial do Aplicativo')}
              items={retornarOpcoesTelasIniciais(dados)}
              value={this.state.configuracaoTelaInicial}
              onChange={this.handleDropDownTelasIniciaisChange}
              emptyMessage={translate('Sua busca não retornou resultados')}
            />
          </Card.Section>
          {exibirTelaInclusaoPonto(dados) && (
            <Card.Section>
              <CheckBox
                nativeID="configuracoes-tela-inicial-forcar-incluir-ponto"
                label={translate(
                  'Abrir em Incluir Ponto quando próximo do horário da marcação'
                )}
                value={this.state.forcarTelaInicial}
                onChange={this.handleForcarTelaInicialChange}
              />
              <Space height={8} />
              <Text color={theme.textColor2} size={12}>
                {translate(
                  'A tela inicial será Incluir Ponto quando até {0} min antes/depois do horário esperado para a marcação',
                  MINUTOS_LIMITE_FORCAR_TELA_INICIAL.toString()
                )}
              </Text>
            </Card.Section>
          )}
        </Card>
        {exibirTelaInclusaoPonto(dados) && (
          <>
            <Space />
            <Card>
              <Card.Header
                nativeID="configuracoes-comprovante-registro-ponto"
                title={translate('Comprovante de Registro de Ponto')}
                titleStyle={styles.titleHeader}
              />
              <Card.Section>
                <CheckBox
                  nativeID="campo-comprovante-registro-ponto"
                  label={translate(
                    'Receber email com comprovante da inclusão de ponto'
                  )}
                  value={dados.receberEmailComprovantePonto}
                  onChange={this.handleReceberEmailComprovantePontoChange}
                />
                <Space height={8} />
                <Text color={theme.textColor2} size={12}>
                  {translate(
                    'Você receberá o comprovante no email informado junto ao seu cadastro na empresa'
                  )}
                </Text>
              </Card.Section>
            </Card>
          </>
        )}
        <Space />
        <Card>
          <Card.Header
            nativeID="configuracoes-identificacao-dispositivo"
            title={translate('Identificação do Dispositivo')}
            titleStyle={styles.titleHeader}
          />
          <Card.Section>
            <TextBox
              label={translateFirstUpper('Identificação')}
              editable={false}
              value={dados.loginIdentificacaoNavegador}
            />
            <Space />
            <TextBox
              label={translateFirstUpper('Endereço IP')}
              editable={false}
              value={dados.loginEnderecoIp}
            />
            <Space />
            <TextBox
              label={translate('Apelido')}
              editable={false}
              value={dados.loginDadosNavegador}
            />
            <Space height={8} />
            <Text color={theme.textColor2} size={12}>
              {translate(
                'Para a versão Web a identificação fica salva no navegador. Caso os dados do navegador forem limpos, será gerada uma nova identificação.'
              )}
            </Text>
          </Card.Section>
        </Card>
        <Space />
        <Card>
          <Card.Header
            nativeID="configuracoes-idioma"
            title={translate('Idioma')}
            titleStyle={styles.titleHeader}
          />
          <Card.Section style={styles.section}>
            <DropDown
              label={translate('Idioma')}
              items={itensConfiguracoesIdiomas}
              value={this.state.configuracoesIdiomas}
              onChange={this.handleDropDownIdiomasChange}
              nativeID="configuracoes-dropdown-idioma"
              emptyMessage={translate('Sua busca não retornou resultados')}
            />
          </Card.Section>
        </Card>
        <Space />
        <Card>
          <Card.Section style={styles.sectionButton}>
            <Button
              nativeID="deletar-conta"
              text="Deletar Conta"
              style={styles.button}
              onPress={() => {
                navegar({ props: this.props, path: '/deletar-conta' });
              }}
            />
          </Card.Section>
        </Card>
        <Space />
        {versaoApp && (
          <>
            <Space />
            <Card>
              <Card.Section>
                <Text bold align={'center'}>
                  {translate('Secullum Ponto Web - Central do Funcionário')}
                </Text>
                <Text
                  size={12}
                  color={theme.textColor2}
                  align={'center'}
                >{`${translate('Versão')} ${versaoApp}`}</Text>
              </Card.Section>
            </Card>
          </>
        )}
        {this.state.mostrarModalConfirmarEmail && (
          <ModalConfirmarEmail
            dadosFuncionario={dados}
            onConcluir={async () => {
              await this.salvarConfiguracaoEmailComprovantePontoAsync(true);
              this.setState({ mostrarModalConfirmarEmail: false });
            }}
            onCancelar={() => {
              this.setState({ mostrarModalConfirmarEmail: false });
            }}
          />
        )}
      </LoggedInScreen>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  section: {
    margin: 'auto',
    maxWidth: 350,
    width: '100%'
  },
  titleHeader: {
    color: theme.textColor2,
    fontSize: isTablet() ? 16 : 12,
    fontFamily: theme.fontFamily2
  },
  sectionButton: {
    alignItems: 'center'
  },
  button: {
    width: '100%',
    maxWidth: 318,
    backgroundColor: RED
  }
});

export default withContainer(
  FuncionarioContainer,
  'funcionarioContainer'
)(Configuracao);
